import Phaser from 'phaser';
import { GameConfig } from '../config/GameConfig';

export class PreloadScene extends Phaser.Scene {
  constructor() {
    super({ key: 'PreloadScene' });
  }

  preload(): void {
    this.load.json('weaponData', 'src/data/weapons.json');
  }

  create(): void {
    (GameConfig as any).WEAPON_DATA = this.cache.json.get('weaponData');
    this.scene.start('MainMenuScene');
  }
}
